import styled from 'styled-components';

export const Timer = styled.div`
	color: rgba(255, 0, 204, 1);
`;
